export default class domCreator 
{
    constructor(options){
        this.parent=options.parent
        this.tag=options.tag
        this.class=options.class
        this.id=options.id
        this.content=options.content
        this.style=options.style
        this.element={}
        this.setElement()
    }
    setElement(){
        this.element = document.createElement(this.tag)
        this.element.classList.add(...this.class)
        if (this.style) this.element.style.cssText=this.style
        if (this.id) this.element.id=this.id
        if (this.content){
            if (typeof(this.content)==='string'){
                this.element.appendChild(document.createTextNode(this.content))
            }else{
                this.element.append(this.content)
            }    
        }
        this.parent.append(this.element)
    }
    hide(){
        this.element.classList.remove('show')
        this.element.classList.add('hided')
    }
    show(){
        this.element.classList.remove('hided')
        this.element.classList.add('show')
    }
}